import React from "react";
import { Box, Flex, Heading, Text } from "@chakra-ui/react";
import { format } from "date-fns";
import { Table } from "components";
import { useCurrentCase, useOrganizationSettings } from "duck";
import { Create, TableCell } from "./components";

const Vitals: React.FC = () => {
  const vitals = useCurrentCase(
    ({ data }) => data.client.patient.postAnestheticVitals
  );
  const patientId = useCurrentCase(({ data }) => data.client.patient._id);
  const { temperatureUnitSymbol } = useOrganizationSettings();

  return (
    <Box>
      <Flex justifyContent="space-between" alignItems="center" mb={4}>
        <Heading as="h3" color="black" fontSize="lg" lineHeight="7">
          Post-Anesthetic Vitals
        </Heading>
        <Create patientId={patientId} />
      </Flex>
      <Table style={{ tableLayout: "fixed" }} data={vitals} editable>
        <Table.Column
          dataKey="timeMonitoring"
          label="Time"
          render={({ value }) => (
            <Text>{format(new Date(value), "h:mm aaaa")}</Text>
          )}
        />
        <Table.Column
          dataKey="temperature"
          label={`Temp. (${temperatureUnitSymbol})`}
          render={record => (
            <TableCell record={record} cellName="temperature" />
          )}
        />
        <Table.Column
          dataKey="heartRate"
          label="HR"
          render={record => <TableCell record={record} cellName="heartRate" />}
        />
        <Table.Column
          dataKey="respiratoryRate"
          label="RR"
          render={record => (
            <TableCell record={record} cellName="respiratoryRate" />
          )}
        />
        <Table.Column
          dataKey="painScore"
          label="Pain Score"
          render={record => <TableCell record={record} cellName="painScore" />}
        />
        <Table.Column
          dataKey="fluidRate"
          label="IV Fluid Rate"
          render={record => <TableCell record={record} cellName="fluidRate" />}
        />
        <Table.Column
          dataKey="comment"
          label="Cmts."
          render={record => (
            <TableCell record={record} cellName="comment" cellType="text" />
          )}
        />
        <Table.Column
          dataKey="initials"
          label="INIT"
          render={record => (
            <TableCell record={record} cellName="initials" cellType="text" />
          )}
        />
      </Table>
    </Box>
  );
};

export default Vitals;
